import axios from "axios";
import CoreService from "./core.service";

axios.defaults.withCredentials = true;

const editProfile = (country_id) => {
    return axios.get(`${CoreService.getPrivateURL()}provinces/${country_id.toString()}`)
};

const getProfile = () =>
    axios.post(`${CoreService.getPrivateURL()}users/me/`, {} ,{withCredentials:true})

const saveInfo = (first_name, last_name, birthday, phone, sendEmail) =>
    axios.put(`${CoreService.getPrivateURL()}users/me/` ,
        {"first_name": first_name, "last_name": last_name, "birthday": birthday, "phone": phone, "send_mail": sendEmail},
        {withCredentials:true})
const changePassword = (values) =>
    axios.put(`${CoreService.getPrivateURL()}users/change_password/` , values, {withCredentials:true})
const ChangePasswordAdminMode = (values) =>
    axios.post(`${CoreService.getPrivateURL()}users/change_password/` , values, {withCredentials:true})
const changeUnit = (values) =>
    axios.post(`${CoreService.getPrivateURL()}users/change_unit/` , values, {withCredentials:true})
const updateUser = (user_id, values) =>
    axios.put(`${CoreService.getPrivateURL()}users/` + user_id , values, {withCredentials:true})

const changeAvatar = (avatarFormData) =>
    axios.post(`${CoreService.getPrivateURL()}users/change_avatar/` ,
                avatarFormData,{withCredentials:true, headers: {'Content-Type': 'multipart/form-data'}})

export const getMe = () => localStorage.getItem("user_object");
export const getUsers = () => axios.get(`${CoreService.getPrivateURL()}users/` ,{withCredentials:true})
export const getStaffs = () => axios.get(`${CoreService.getPrivateURL()}staffs/` ,{withCredentials:true})
export const getUser = (user_id) => axios.get(`${CoreService.getPrivateURL()}users/` + user_id ,{withCredentials:true})
export const addUser = (data) => {
    return axios.post(`${CoreService.getPrivateURL()}users/` , data,{withCredentials:true})
};
export const addBulkUser = (bulkFormData) => {
    return axios.post(
        `${CoreService.getPrivateURL()}users/`,
        bulkFormData,
        {
            withCredentials: true,
            headers: { 'Content-Type': 'multipart/form-data' }
        }
    );
};
export const resendConfirmEmail = (user_id) => {
    return axios.post(`${CoreService.getPrivateURL()}users/${user_id}/resend_confirm` , null, {withCredentials:true})
};
export const disableUser = (user_id) => {
    return axios.patch(`${CoreService.getPrivateURL()}users/${user_id}` , null, {withCredentials:true})
};
export const deleteUser = (user_id) => {
    return axios.delete(`${CoreService.getPrivateURL()}users/${user_id}` , null, {withCredentials:true})
};
export const sendBulkEmail = (userIds, subject, body) => {
    return axios.post(`${CoreService.getPrivateURL()}users/bulk_email` ,
        { user_ids: userIds, subject, body },
        {withCredentials:true})
};
export const createSingle = (values) => {
    return axios.post(`${CoreService.getPrivateURL()}users/create_single` , values, {withCredentials:true})
};
export const createBulk = (values_form) => {
    return axios.post(`${CoreService.getPrivateURL()}users/create_bulk` , values_form, {withCredentials:true,
                        headers:{'Content-Type':'multipart/form-data'}
    })
};

const UserService = {
  createSingle,
  createBulk,
  editProfile,
  saveInfo,
  changeAvatar,
  changePassword,
  ChangePasswordAdminMode,
  updateUser,
  resendConfirmEmail,
  disableUser,
  deleteUser,
  sendBulkEmail,
  getProfile,
  getUsers,
  getStaffs,
  getUser,
  getMe,
};
export default UserService;
